import { TEXT } from 'locales/translations';

const NoSubscription = () => (
  <div>
    <div className="pb-3">{TEXT.subscriptionStatus.noSubscriptionTeaser}</div>
  </div>
);

export default NoSubscription;
